import Loader from '../../../components/Loader/Loader.component';
import React, { useCallback, useState } from 'react';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { Examiner } from '../../../models/taskGroup.types';
import { disableExaminer } from '../../../services/exams/assessmentSession/assessments.service';
import { useShowLoader } from '../../../Context/Layout.context';

export const DisableExaminer: React.FC<{
  examiner: Examiner;
  onSuccess: () => void;
  onFailure: () => void;
  isExaminingTeamChairmen: boolean;
  isVerifier?: boolean;
}> = (props) => {
  const [openSuccessPrompt, setOpenSuccessPrompt] = useState<boolean>(false);
  const [openFailurePrompt, setOpenFailurePrompt] = useState<boolean>(false);
  const [openConfirmationPrompt, setOpenConfirmationPrompt] = useState<boolean>(true);
  const [isLoaderVisible, setIsLoaderVisible] = useState<boolean>(false);

  const showLoader = useShowLoader();

  const disableSelectedExaminer = useCallback(() => {
    showLoader(true);
    setOpenConfirmationPrompt(false);
    disableExaminer(props.examiner.examinerPermission[0]?.examinerPermissionId)
      .then(
        () => {
          setOpenSuccessPrompt(true);
        },
        () => {
          setOpenFailurePrompt(true);
        },
      )
      .finally(() => {
        setIsLoaderVisible(false);
        showLoader(false);
      });
  }, [props.examiner.examinerPermission[0]?.examinerPermissionId]);

  const getPromptSubTexts = (isSuccess?: boolean) => {
    return [
      {
        text: true ? props.examiner.firstName + ' ' + props.examiner.lastName : '',
      },
      {
        text: isSuccess ? 'zakończone sukcesem.' : 'nie powiodło się, spróbuj ponownie później.',
        isBold: true,
      },
    ];
  };

  return (
    <>
      {isLoaderVisible && <Loader />}
      <Prompt
        type="confirmation"
        isBold={true}
        open={openConfirmationPrompt}
        mainText={
          !props.isExaminingTeamChairmen
            ? `Czy na pewno chcesz zablokować ${props.isVerifier ? 'Egzaminatora-Weryfikatora' : 'egzaminatora'}?`
            : 'Czy na pewno chcesz zablokować PZE?'
        }
        subTexts={[
          { text: props.examiner.firstName + ' ' + props.examiner.lastName + ' ?' },
          {
            text: `(Zablokowanie ${
              !props.isExaminingTeamChairmen ? (props.isVerifier ? 'Egzaminatora-Weryfikatora' : 'Egzaminatora') : 'PZE'
            } ${
              props.isVerifier
                ? 'zablokuje odsyłanie zweryfikowanych przez niego prac'
                : 'nie dotyczy pobranych lub ocenianych już rozwiązań zadań'
            })`,
            isBold: true,
          },
        ]}
        onConfirm={disableSelectedExaminer}
        onCancel={props.onFailure}
        mainActionButtonText="TAK"
      />
      <Prompt
        type="error"
        isBold={true}
        open={openFailurePrompt}
        mainText={
          !props.isExaminingTeamChairmen
            ? `Zablokowanie ${props.isVerifier ? 'Egzaminatora-Weryfikatora' : 'Egzaminatora'}`
            : 'Zablokowanie PZE'
        }
        subTexts={getPromptSubTexts(false)}
        onConfirm={props.onFailure}
        mainActionButtonText="POWRÓT DO LISTY"
      />
      <Prompt
        type="success"
        isBold={true}
        open={openSuccessPrompt}
        mainText={
          !props.isExaminingTeamChairmen
            ? `Zablokowanie ${props.isVerifier ? 'Egzaminatora-Weryfikatora' : 'Egzaminatora'}`
            : 'Zablokowanie PZE'
        }
        subTexts={getPromptSubTexts(true)}
        onConfirm={props.onSuccess}
        mainActionButtonText="POWRÓT DO LISTY"
      />
    </>
  );
};

export default DisableExaminer;
